import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

export default {
    namespaced: true,
    state: () => ({
        items: [],
    }),
    actions: {
        SOCKET_onGlobalSendLiveEmoji({ commit }, res){
            console.log('SOCKET_onGlobalSendLiveEmoji ->', res);
            commit('addItem', res);
        }
    },
    mutations: {
        addItem(state, item){
            state.items.push(item);
            setTimeout(() => {
                var emojiID = `#emoji${ state.items.length }`;

                gsap.set(emojiID, { scale: 0.01, autoAlpha: 1 });

                gsap.to(emojiID, {
                    duration: _.random(3.1, 4.0), 
                    ease: "power2.inOut",
                    immediateRender: true,
                    motionPath: {
                        path: "#path",
                        align: "#path",
                        alignOrigin: [0.5, 0.5],
                        autoRotate: 90
                    }
                });

                gsap.to(emojiID, {
                    duration: _.random(0.8, 1.2), 
                    delay: _.random(2.5, 3.3),
                    opacity: 0,
                    ease: 'power2.out',
                });

                gsap.to(emojiID, {
                    duration: _.random(1.5, 2.0), 
                    scale: 1,
                    ease: 'elastic.out',
                });
            }, 500);            
        }
    }
}

